import { useGetCategoriesQuery } from '../app/api-slice';
import { ChooseCategory } from '../view/choose-category';
import { LoadingPage } from './loading-page';
import { ErrorPage } from './error-page';
import { useMessages2 } from '../hooks/useLanguage';
import { allowedCurrenciesSelector, currentCurrencySelector, isAnonymousSelector, mainActions, useDataRequestLang, useURLLang } from '../app/main-slice';
import { PageMetadata } from '../view/page-metadata';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { showPopup } from '../app/popup-slice';
import Popup from '../controls/popup/popup';
import { basketActions } from '../app/basket-slice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SaveState } from '../app/types/api-types';
import { urls } from '../navigation';
import { useEffect } from 'react';

export const ChooseCategoryPage = () => {

    const [ searchParams ] = useSearchParams();
    const lang = useDataRequestLang();
    const { data: categories = [], isLoading, isSuccess, isError, error } = useGetCategoriesQuery(lang);
    const {isLoading: isLoadingMessage, isSuccess: isSuccessMessage, messages } = useMessages2();
    const currentCurrency = useAppSelector(currentCurrencySelector);
    const allowedCurrencies = useAppSelector(allowedCurrenciesSelector);
    const dispatch = useAppDispatch();
    const langId = useURLLang();
    const navigate = useNavigate();
    const isAnonymous = useAppSelector(isAnonymousSelector);

    const onViewBaskets = () => {
        dispatch(basketActions.openFromHome());
        dispatch(showPopup({
            dialog: 'baskets'
        }))
    }

    const onLoadPreviousConfig = () => {
        dispatch(showPopup({
            dialog: 'loadConfig'
        }))
    }

    const onSelectCurrency = (v:string) => {
        dispatch(mainActions.setCurrentCurrency(v));
    }

    const onLogOut = () => {
        dispatch(mainActions.logout());
    }

    const code = searchParams.get('C');
    const cartCode = searchParams.get('SC');

    useEffect(() => {
        if(cartCode && isAnonymous) {
            navigate(urls.home('app', { cartCode, language: langId }))
        }        
    }, [ cartCode, isAnonymous, langId ])

    useEffect(() => {
        // this should work using then, but for some reason, doesn't catch the error
        const asyncFn = async () => {
            if(code && isSuccessMessage) {
                try {
                    const result = await dispatch(basketActions.editBasketByCode({ code }));
                    const savedState = result.payload as SaveState;
                    if(savedState.variant) {
                        navigate(urls.variantCfg(langId, savedState.category, savedState.family, savedState.variant));
                    } else {
                        navigate(urls.familyCfg(langId, savedState.category, savedState.family));
                    }                
                } catch(err: unknown) {
                    dispatch(showPopup({
                        dialog: 'message',
                        popupContent: {
                            messages: [
                                messages?.previous_load_error ?? ''
                            ]
                        }
                    }));  
                }
            }
        }
        asyncFn();
    
    }, [ code, messages, isSuccessMessage ])

    useEffect(() => {
        // this should work using then, but for some reason, doesn't catch the error
        const asyncFn = async () => {
            if(cartCode && isSuccessMessage && !isAnonymous) {
                try {
                    await dispatch(basketActions.editCartByCode({ cartCode }));
                    await dispatch(showPopup({ dialog: 'baskets' }));
                } catch(err: unknown) {
                    dispatch(showPopup({
                        dialog: 'message',
                        popupContent: {
                            messages: [
                                messages?.previous_load_error ?? ''
                            ]
                        }
                    }));  
                }
            }
        }
        asyncFn();
    
    }, [ cartCode, messages, isSuccessMessage, isAnonymous ]);


    let content;    

    if(isLoading || isLoadingMessage) {
        content = <LoadingPage/>
    } else if(isSuccess && isSuccessMessage) {
        content = <ChooseCategory categories={categories} 
                                  currentCurrency={currentCurrency}
                                  allowedCurrencies={allowedCurrencies}
                                  onLoadPreviousConfig={onLoadPreviousConfig}
                                  onViewBaskets={onViewBaskets}
                                  onSelectCurrency={onSelectCurrency}
                                  onLogOut={onLogOut}/>
    } else {
        content = <ErrorPage error={error}/>
    }

    const pageTitle = (messages?.intro_category_question ?? '').replace(/\.$/, '');

    return <>
        <PageMetadata pageTitle={ pageTitle } />
        { content }
        <Popup/>
    </>;
}